/**
 * Login wall type
 */
export const LOGIN = 'LOGIN';

/**
 * Paywall wall type
 */
export const PAYWALL = 'PAYWALL';

/**
 * Wall types
 */
export const WALL_TYPE = {
  LOGIN,
  PAYWALL,
} as const;
